<script setup lang="ts">
import { onBeforeUnmount, ref, watch } from 'vue';
import { useInjectGameEngine } from '../composables/useGameEngine';

const gameEngine = useInjectGameEngine();
const comboValue = ref<HTMLElement>();

const restartComboAnimation = () => {
  const element = comboValue.value;
  if (!element) return;

  element.classList.remove('combo-value-enter');
  void element.offsetWidth;
  element.classList.add('combo-value-enter');
};

watch(() => gameEngine.comboCount.value, restartComboAnimation, { flush: 'post' });

onBeforeUnmount(() => {
  comboValue.value?.classList.remove('combo-value-enter');
});
</script>

<template>
  <div class="combo-counter absolute top-2 left-1/2 -translate-x-1/2 flex flex-col items-center">
    <div class="text-md text-text-secondary">
      COMBO
    </div>
    <div
      ref="comboValue"
      class="text-3xl font-bold combo-value combo-value-enter"
      :class="{
        'text-text-primary': gameEngine.comboCount.value < 5,
        'text-yellow-400': gameEngine.comboCount.value >= 5 && gameEngine.comboCount.value < 10,
        'text-orange-400': gameEngine.comboCount.value >= 10 && gameEngine.comboCount.value < 20,
        'text-red-400': gameEngine.comboCount.value >= 20 && gameEngine.comboCount.value < 50,
        'text-secondary-500 pulse-animation': gameEngine.comboCount.value >= 50
      }"
    >
      {{ gameEngine.comboCount.value }}
    </div>
  </div>
</template>

<style>
.combo-counter {
  z-index: 10;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.8);
}

.combo-value {
  transition: color 0.3s ease, transform 0.2s ease;
}

.combo-value-enter {
  animation: combo-value 0.3s ease-out forwards;
}

@keyframes combo-value {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  20% {
    opacity: 0.9;
    transform: translateY(0);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.pulse-animation {
  animation: combo-pulse 1s infinite alternate;
}

@keyframes combo-pulse {
  0% {
    transform: scale(1);
    text-shadow: 0 0 2px rgba(136, 102, 0, 0.8);
  }
  100% {
    transform: scale(1.1);
    text-shadow: 0 0 5px rgba(136, 102, 0, 0.8);
  }
}
</style> 